import React from 'react';
import { useIntl } from 'react-intl';
import ViewTableInformation from '../../../Common/TableRecords/ViewTableInformation';
import ViewTableBodyInformation from '../../../Common/TableRecords/ViewTableBodyInformation';
import { AdminEarningsIcons } from '../../../../components/Common/Assets/SvgIconComponent/SideMenuIcons';
import messages from '../../../../locale/jsonMessages';

const AdminEarning = ({ data }) => {
    const { formatMessage } = useIntl();
    let guestFee = 0, hostFee = 0, convertCurrency, earnings = 0, promoDiscount = 0, promoCodeType;

    if (data?.cancellationDetails) {
        guestFee = data?.cancellationDetails?.guestServiceFee;
        hostFee = data?.cancellationDetails?.hostServiceFee;
        convertCurrency = data?.cancellationDetails?.currency;
        promoDiscount = data?.cancellationDetails?.promoDiscount;
        promoCodeType = data?.cancellationDetails?.promoCodeType
    } else if (data) {
        guestFee = data?.guestServiceFee;
        hostFee = data?.hostServiceFee;
        convertCurrency = data?.currency;
        promoDiscount = data?.promoDiscount;
        promoCodeType = data?.promoCodeType
    }
    if (data && (data?.reservationState == 'expired' || data?.reservationState == 'declined')) {
        guestFee = 0;
        hostFee = 0;
    }
    // earnings = guestFee + hostFee;
    let overdraftAmount = 0;

    const totalFee = guestFee + hostFee;

    if (promoCodeType == 'admin') {
        earnings = totalFee - promoDiscount;
    } else {
        earnings = totalFee;
    }

    if (earnings < 0 && promoCodeType == 'admin') {
        overdraftAmount = earnings;
        earnings = 0;
    }
    return (
        <div>
            <ViewTableInformation title={formatMessage(messages.adminEarnings)} icon={<AdminEarningsIcons />}>
                <ViewTableBodyInformation
                    title={formatMessage(messages.renterServiceFee)}
                    currencyData
                    amount={guestFee}
                    convertCurrency={convertCurrency}
                />
                <ViewTableBodyInformation
                    title={formatMessage(messages.carOwnerServiceFee)}
                    currencyData
                    amount={hostFee}
                    convertCurrency={convertCurrency}
                />
                {data?.promoCodeType == 'admin' && <ViewTableBodyInformation
                    title={formatMessage(messages.couponAmountLabel)}
                    currencyData
                    isMinus
                    amount={promoDiscount}
                    convertCurrency={convertCurrency}
                />}
                <ViewTableBodyInformation
                    title={formatMessage(messages.yourEarnings)}
                    currencyData
                    amount={earnings}
                    convertCurrency={convertCurrency}
                    isBold
                />
                <ViewTableBodyInformation
                    title={formatMessage(messages.overDraftLabel)}
                    currencyData
                    amount={overdraftAmount}
                    convertCurrency={convertCurrency}
                />
            </ViewTableInformation>
        </div>
    )
}

export default AdminEarning;
